import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10.24,
	height: 10.24,
	fill: "#fff",
	viewBox: "0 0 10.24 10.24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6712",
		"data-name": "Path 6712",
		d: "M15.421,5.642a.773.773,0,0,0-1.1,0l-3.8,3.79-3.8-3.8a.774.774,0,0,0-1.1,1.1l3.8,3.8-3.8,3.8a.774.774,0,0,0,1.1,1.1l3.8-3.8,3.8,3.8a.774.774,0,0,0,1.1-1.1l-3.8-3.8,3.8-3.8A.778.778,0,0,0,15.421,5.642Z",
		transform: "translate(-5.408 -5.408)"
	})
});
export { SvgClose as ReactComponent };
